export const FETCH_FAQ_CATEGORIES_REQUEST = 'FETCH_FAQ_CATEGORIES_REQUEST';
export const FETCH_FAQ_CATEGORIES_SUCCESS = 'FETCH_FAQ_CATEGORIES_SUCCESS';
export const FETCH_FAQ_CATEGORIES_FAILURE = 'FETCH_FAQ_CATEGORIES_FAILURE';

export const fetchFaqCategoriesRequest = () => ({
  type: FETCH_FAQ_CATEGORIES_REQUEST
});

export const fetchFaqCategoriesSuccess = response => ({
  type: FETCH_FAQ_CATEGORIES_SUCCESS,
  payload: response,
  meta: { content: true }
});

export const fetchFaqCategoriesFailure = err => ({
  type: FETCH_FAQ_CATEGORIES_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/faq/actions.js